﻿export interface IWatrDecline {
    requestId: number,
    userId: number,
    userFirstName: string,
    userLastName: string,
    updatedByAlias: string,
    logDate: string,
    logMessage: string
}